import React, { useState, useEffect } from 'react';
import ImageApi from '../../../api/image';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CommunityItem = ({ id, imageId, title, imageData, description }) => {
  const [image, setImage] = useState('');

  useEffect(() => {
    if (imageData && imageData.thumbnailUrl) {
      ImageApi.getImage(imageData.thumbnailUrl).then((imageUrl) => {
        setImage(imageUrl);
      });
    }
  }, [image, imageData]);

  return (
    <Link to={`/communities/${id}`} className="communities-container-item">
      <div className="communities-container-hub-list-upper">
        {image && imageId ? (
          <img
            className="communities-container-hub-list-image"
            src={image}
            alt="community-thumbnail"
          />
        ) : null}
        <div className="communities-container-hub-list-content">
          <p className="communities-container-hub-list-title">{title}</p>
          <p className="communities-container-hub-list-description">{description}</p>
        </div>
        <FontAwesomeIcon
          icon={['fas', 'chevron-right']}
          className="communities-back-link-icon"
        />
      </div>
    </Link>
  );
};

export default CommunityItem;
